<script>
import { UsersApi } from '@/api/resources'
import { Adapter } from '@/store/createCrudModule'
import BAutocompleteUser from './BAutocompleteUser.vue'


class AdapterUserGroup extends Adapter {
  getAll(payload, rawParams) {
    const { params, options } = this.transformerParams.getAll(payload, rawParams)

    return this.api.autocompleteForGroup(params, options)
      .then((response) => this.transformerData.getAll(response, payload))
  }
}

export default {
  name: 'BAutocompleteUserGroup',
  extends: BAutocompleteUser,
  created() {
    const api = new UsersApi()
    this.adapter = new AdapterUserGroup(api)
  },
  methods: {
    request(...args) {
      return this.adapter.getAll(...args)
    },
  },
}
</script>
